<template>
  <div class="f-readCartaModal">
    <b-modal id="readCartaModal"
             ref="readCartaModal"
             centered
             size="lg"
             :title="modalTitle">
      <p class="my-4">{{activeLanguage.chartaContent.chapter1.text}}</p>

      <div slot="modal-footer" class="w-100">
        <b-button class="button-style float-left" @click="loadPaper">{{activeLanguage.readMore}}</b-button>
        <b-button class="button-style float-right" @click="loadSignPetition">{{activeLanguage.signPetition}}</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import SignPetitionPage from '../../signPetitionPageComponents/SignPetitionPage'
  import PaperPage from '../../paperPageComponents/PaperPage'

  export default {
    name: 'ReadCartaModal',
    computed: {
      activeLanguage () {
        let currLang = this.$translations[this.$store.getters.currentLanguageValue]
        if (currLang.chartaContent) {
          return this.$translations[this.$store.getters.currentLanguageValue]
        } else {
          return this.$translations['English']
        }
      },
      modalTitle () {
        return this.activeLanguage.read + ' ' + this.activeLanguage.theCarta
      }
    },
    methods: {
      showModal () {
        this.$refs.readCartaModal.show()
      },
      hideModal () {
        this.$refs.readCartaModal.hide()
      },
      loadSignPetition () {
        this.$store.commit('setCurrentView', SignPetitionPage)
        this.$router.push('/sign-petition')
      },
      loadPaper () {
        this.$store.commit('setCurrentView', PaperPage)
        this.$router.push('/paper')
      }
    },
    mounted () {
      document.getElementById('readCartaModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;')
      document.getElementById('readCartaModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;')
    }
  }
</script>

<style scoped>


  .button-style {
    background-color: #c41c21 !important;
    border-color: #c41c21 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/cartaAlpFoodWay/ReadCartaModal.vue